module.exports = __webpack_public_path__ + "static/block5-de9cad1288db96fc5b95972c2a0319c7.jpg";